/* @flow weak */
export const EventTrackingConstants = {
  UNIVERSAL_COMPOSER_CLASSES: 'universal_composer_classes',
};



// WEBPACK FOOTER //
// ./src/constants/EventTrackingConstants.js